import { lazy } from "react";

// Lazy load with retry mechanism
const lazyLoadComponent = (
  importFn: () => Promise<any>,
  retries = 3
): React.LazyExoticComponent<any> => {
  const LazyComponent = lazy(async () => {
    let lastError: Error | null = null;
    for (let i = 0; i < retries; i++) {
      try {
        const module = await importFn();
        if (!module.default) {
          throw new Error("Module does not have a default export");
        }
        return module;
      } catch (err) {
        lastError = err as Error;
        await new Promise((resolve) =>
          setTimeout(resolve, 1000 * Math.pow(2, i)) // exponential backoff
        );
      }
    }
    throw lastError;
  });

  (LazyComponent as any).preload = importFn;
  return LazyComponent;
};

// Prefetch strategies
export type PrefetchStrategy = "none" | "viewport" | "hover";

export interface RouteConfig {
  path: string;
  component: React.LazyExoticComponent<any>;
  prerender: boolean;
  prefetch: PrefetchStrategy;
  cacheControl: string;
  isProtected?: boolean;
  requiredRole?: string | string[];
  label?: string;
}

// Routes list
export const routes: RouteConfig[] = [
  {
    path: "/",
    component: lazyLoadComponent(() => import("../components/pages/Home")),
    prerender: false,
    prefetch: "none",
    cacheControl: "private, no-cache",
    isProtected: true,
    label: "Home",
  },
  {
    path: "/login",
    component: lazyLoadComponent(() => import("../components/pages/Login")),
    prerender: false,
    prefetch: "none",
    cacheControl: "no-store",
    isProtected: false,
    label: "Login",
  },
  {
    path: "/profile",
    component: lazyLoadComponent(() => import("../components/pages/Profile")),
    prerender: false,
    prefetch: "none",
    cacheControl: "private, no-cache",
    isProtected: false,
    label: "Profile",
  },
  {
    path: "/courses",
    component: lazyLoadComponent(() => import("../components/pages/Courses")),
    prerender: false,
    prefetch: "hover",
    cacheControl: "private, max-age=300",
    isProtected: true,
    requiredRole: "subscriber",
    label: "Courses",
  },
{
  path: "/course/:slug",
  component: lazyLoadComponent(() => import("../components/pages/CourseDetail")),
   prerender: false,
    prefetch: "hover",
    cacheControl: "private, max-age=300",
    isProtected: true,
    requiredRole: "subscriber",
    label: "Courses",
},

  {
     path: "/course/:courseSlug/lesson/:id",
    component: lazyLoadComponent(() => import("../components/pages/LessonPage")),
    prerender: false,
    prefetch: "hover",
    cacheControl: "private, max-age=300",
    isProtected: true,
    requiredRole: "subscriber",
    label: "Lesson",
  },
];

